<template>
  <div class="record">
    <div class="searchbox order_searchbox">
      <form action="#" method="get" class="form-inline form-float">
        <div class="form-group">
          <label for>会员卡名称:</label>
          <el-select v-model.trim="search.rentMonthChargeId">
            <el-option
              v-for="rent in rentMonthList"
              :value="rent.id"
              :key="rent.id"
              :label="rent.name"
            ></el-option>
          </el-select>
        </div>
        <div class="form-group">
          <label for="bdate">起止时间:</label>
          <el-date-picker
            :clearable="false"
            v-model="search.dateRange"
            type="monthrange"
            range-separator="至"
            start-placeholder="开始月份"
            end-placeholder="结束月份"
            :unlink-panels="true"
          >
          </el-date-picker>
        </div>

        <div class="form-group others">
          <span class="search_btn">
            <el-button
              @click="searchList"
              type="button"
              class="btn btn-primary"
              id="search_btn"
              :loading="loading"
            >
              查询
            </el-button>
          </span>
          <span class="download_btn">
            <el-button
              type="primary"
              size="small"
              @click="downloadExcel"
              :loading="downloadLoading"
              >导出EXCEL</el-button
            >
          </span>
        </div>
      </form>
    </div>
    <div class="list-right">
      <el-table
        v-loading="loading"
        ref="table"
        border
        :data="tableListData.rows"
        height="100%"
        width="100%"
        :header-cell-style="tableHeaderStyle"
        :cell-style="styleObj"
        @selection-change="onSelectionChange"
        show-summary
        :summary-method="getSummaries"
      >
        <el-table-column
          show-overflow-tooltip
          type="selection"
          width="55"
        ></el-table-column>
        <el-table-column
          show-overflow-tooltip
          label="统计时间"
          prop="chargeDate"
        >
        </el-table-column>
        <el-table-column
          show-overflow-tooltip
          label="会员卡名称"
          prop="chargeName"
        >
        </el-table-column>
        <el-table-column show-overflow-tooltip label="金额" prop="totalRealPay">
        </el-table-column>
        <el-table-column show-overflow-tooltip label="购买数量" prop="crtNum">
        </el-table-column>
      </el-table>
    </div>

    <Page
      v-on:pagination="receivePaginationData"
      v-bind:pageObj="pageObj"
    ></Page>
  </div>
</template>

<script>
import { mapMutations, mapActions, mapGetters } from "vuex";

import { rentMonthOrderMonthlyStatement, rentMonthPage } from "@/api/url";

import Page from "@/page/commons/page";

import dayjs from "dayjs";

export default {
  data() {
    return {
      styleObj: {
        "text-align": "center",
      },

      tableHeaderStyle: {
        "text-align": "center",
        background: "#F9F9FB",
      },

      search: {
        pageNumber: 1,
        pageSize: 10,

        dateRange: [],
        rentMonthChargeId: "",
      },
      tableListData: {},
      pageObj: {},
      selectedList: [],
      totalMap: {},
      loading: false,
      downloadLoading: false,
      rentMonthList: [],
    };
  },
  components: {
    Page,
  },
  computed: {},

  created: function() {},
  mounted: function() {
    this.search = {
      ...this.search,
      dateRange: [
        dayjs()
          .startOf("year")
          .format("YYYY-MM"),
        dayjs().format("YYYY-MM"),
      ],
    };
    this.search.pageNumber = 1;
    this.tableList(this.search.pageNumber);
    this.getrentMonth();
  },

  watch: {},
  methods: {
    ...mapMutations("tabNavigation", ["delNavigation"]),
    ...mapMutations(["getPage"]),
    receivePaginationData(v1, v2) {
      this.search.pageNumber = v1;
      this.search.pageSize = v2;
      this.tableList(this.search.pageNumber);
    },
    onSelectionChange(val) {
      this.selectedList = [...val];
    },

    tableList: function(curPage) {
      var _this = this;
      this.loading = true;
      const { dateRange, rentMonthChargeId, pageSize } = this.search;
      let params = {
        limit: pageSize,
        page: curPage,
      };
      if (rentMonthChargeId) {
        params = {
          ...params,
          rentMonthChargeId,
        };
      }

      if (dateRange?.length > 0) {
        params = {
          ...params,
          beginTime: this.formatDate(dateRange[0]),
          endTime: this.formatDate(dateRange[1]),
        };
      }

      this.$get(rentMonthOrderMonthlyStatement(), {
        ...params,
      })
        .then((data) => {
          if (data.status != 200) return;
          //翻页
          var rows = data.data.rows;
          var pageObj = {
            curIndex: data.data.offset,
            rowsCount: data.data.total,
          };
          _this.pageObj = { ...pageObj };
          // _this.getPage(pageObj);
          _this.tableListData = {
            ...data?.data,
            rows: data?.data?.rows ?? {},
          };
          _this.totalMap = data?.data?.totalMap ?? {};
        })
        .finally(() => {
          this.loading = false;
        });
    },
    searchList: function() {
      this.search.pageNumber = 1;
      this.tableList(this.search.pageNumber);
    },

    downloadExcel() {
      const { dateRange, rentMonthChargeId } = this.search;
      let params = {};
      if (rentMonthChargeId) {
        params = {
          ...params,
          rentMonthChargeId,
        };
      }

      if (dateRange?.length > 0) {
        params = {
          ...params,
          beginTime: this.formatDate(dateRange[0]),
          endTime: this.formatDate(dateRange[1]),
        };
      }
      this.downloadLoading = true;
      this.$downloadFileRequest(
        `/api/parking/rentMonthOrder/monthlyReportExport`,
        { ...params },
        "会员卡月报"
      ).finally(() => {
        this.downloadLoading = false;
      });
    },
    jsonToUrlParams(json) {
      var paramsArray = [];
      for (var key in json) {
        if (json.hasOwnProperty(key)) {
          var value = json[key];
          var pair = encodeURIComponent(key) + "=" + encodeURIComponent(value);
          paramsArray.push(pair);
        }
      }
      return paramsArray.join("&");
    },
    getSummaries(param) {
      const { columns, data } = param;
      const sums = [];
      columns.forEach((column, index) => {
        if (index === 0) {
          sums[index] = "总计";
        }
        if (index === 3) {
          sums[index] = this.totalMap?.totalRealPay ?? 0;
        }
        if (index === 4) {
          sums[index] = this.totalMap?.totalCrtNum ?? 0;
        }
      });
      return sums;
    },
    formatDate(date) {
      return dayjs(date).format("YYYY-MM");
    },
    onCurrentDateChange(v) {
      this.search.entryDate = [...v];
    },
    getrentMonth() {
      this.$get(rentMonthPage(), {
        limit: 100,
        page: 1,
      })
        .then((data) => {
          if (data.status != 200) return;
          this.rentMonthList = data?.data?.rows ?? [];
        })
        .finally(() => {});
    },
  },
};
</script>
<style scoped>
.modal-body .tab-img li {
  width: 100px;
  height: 100px;
  margin: 10px 10px;
}

.searchbox {
  border-bottom: none !important;
  width: 100%;
  padding-left: 10px;
  background: white !important;
}

.refresh {
  display: inline-block;
}

.bread_container {
  display: inline-block !important;
  border: none !important;
  padding: 0 !important;
}

/* .photo{
              width:60px;
              font-size:12px;
              background:#409EFF;
              color:white;
              height:20px;
              line-height:20px;
              
          } */
.imgDialog {
  overflow: hidden;
}
button.photo {
  height: 22px;
  line-height: 22px;
  color: #278cd8;
  background: none;
  font-size: 12px;
  margin-right: 5px;
}

.photoN {
  width: 350px;
  line-height: 300px;
  height: 300px;
  text-align: center;
  display: inline-block;
}

.imgDialog {
  animation: opacity2 3s;
  -webkit-animation: opacity2 3s;
  -moz-animation: opacity2 3s;
}

@keyframes opacity2 {
  0% {
    opacity: 0;
  }

  50% {
    opacity: 0.5;
  }

  100% {
    opacity: 1;
  }
}

@-webkit-keyframes opacity2 {
  0% {
    opacity: 0;
  }

  50% {
    opacity: 0.5;
  }

  100% {
    opacity: 1;
  }
}

@-moz-keyframes opacity2 {
  0% {
    opacity: 0;
  }

  50% {
    opacity: 0.5;
  }

  100% {
    opacity: 1;
  }
}

button.gray {
  color: gray;
}
.form-group {
  margin-bottom: 10px;
}
.gap {
  margin-right: 5px;
}
</style>
<style>
.record .el-date-editor {
  width: auto;
}
.record .el-date-editor.el-input__inner {
  max-width: none;
}
.record .el-date-editor .el-range-input {
  font-size: 12px !important;
}

.record .el-date-editor .el-range-separator {
  font-size: 12px !important;
}

.record .imgDialog .el-dialog__header {
  display: none;
  padding: 0;
}

.record .imgDialog .el-dialog__body {
  padding: 0 !important;
}

.record .imgDialog .el-dialog__footer {
  padding: 0 !important;
}

.record .searchbox .el-select {
  width: 150px !important;
}

.record .order_searchbox .form-control {
  width: 150px;
}

.record .el-dialog {
  margin-top: 10vh !important;
}

/* .el-dropdown-link {
           display: inline-block;;
          cursor: pointer;
          color:white;
          background:#278cd8;
          height:34px;
          border-radius: 5px;
          padding-left:5px;
          font-size: 12px;
          line-height:37px;
          width:90px;
        } */
.record .el-icon-arrow-down {
  font-size: 12px;
}

.record .dowload {
  padding-left: 10px;
  display: inline-block;
}

.record .img-container {
  display: flex;
  justify-content: space-between;
  align-items: center;
  box-sizing: border-box;
  padding: 20px 0 20px 20px;
}

.record img {
  overflow: hidden;
}

.record .img-container img {
  box-sizing: border-box;
  padding-right: 20px;
}

.record .searchbox .form-inline {
  overflow: auto;
}
.record .is-gray {
  color: #666;
  cursor: not-allowed;
}
</style>
<style>
.record .modify-plate .el-input__inner {
  height: 40px;
}
.record .modify-plate .el-select {
  width: 100%;
}
.record .list-right {
  height: calc(100vh - 220px);
  overflow-x: hidden;
  overflow-y: auto;
  padding-bottom: 50px;
}

/* 表格容器在小屏幕时允许横向滚动 */
@media (max-width: 1280px) {
  .record .list-right {
    overflow-x: auto !important;
  }
}

.record .el-table__footer-wrapper tbody td.el-table__cell {
  text-align: center;
  color: red;
}
.record .batchDel_btn .btn:hover,
.record .batchDel_btn .btn:focus {
  color: #278cd8;
  border: 1px solid #278cd8;
  background: white;
}
</style>
